module.exports = new __parcel__URL__("../images/cpi.f6333734.png").toString();